import type { UpdateUserFormSettingMutation, UpdateUserFormSettingMutationVariables } from '@/typings/domain'
import apolloClient from './apolloClient'

import UpdateUserFormSettingGQL from '@/lib/api/graphql/UpdateUserFormSetting.graphql'

export function updateUserFormSetting(variables: UpdateUserFormSettingMutationVariables['input']) {
  return apolloClient.mutate<UpdateUserFormSettingMutation, UpdateUserFormSettingMutationVariables>({
    mutation: UpdateUserFormSettingGQL,
    variables: { input: variables },
    fetchPolicy: 'no-cache',
  })
}
